<template>
  <div class="yuyueguahao">
    <van-loading v-show="loading" class="my-loading" type="spinner" color="#1989fa" />
    <div v-show="!loading" class="yishengliebiao">医生列表</div>
    <ul v-show="!loading && doctorJobList.length > 0" class="list-wrap">
      <li v-for="(item,index) in doctorJobList" :key="index" class="list" @click="goTo(item)">
        <div class="img-wrap">
          <!-- <img v-if="item.doctorSex==='8'" class="doctor-img" src="../../assets/images/doctor_pic.png" />
           <img v-else-if="item.doctorSex==='7'" class="doctor-img" src="../../assets/images/doctor_pic_man.png" /> -->
          <img class="doctor-img" src="../../assets/images/doctor.png">
        </div>
        <div class="info-wrap">
          <div class="name">{{ item.doctorName }}</div>
          <div
            class="desc"
            :class="{ 'desc-expanded': expandMap[index] }"
            :data-has-more="hasMoreContent(item.doctorGood)"
          >
            {{ item.doctorGood }}
            <div
              v-if="hasMoreContent(item.doctorGood)"
              class="expand-btn"
              @click.stop="toggleExpand(index)"
            >
              <van-icon name="arrow-down" :class="{ 'is-expanded': expandMap[index] }" />
            </div>
          </div>
          <div v-if="!deptCode" style="display:flex;">
            <div class="title-wrap">
              <div class="title-img">
                <img class="v-img" src="../../assets/images/v_pic.png">
              </div>
              <div class="title">{{ item.titleName }}</div>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <noData v-if="!loading && doctorJobList.length === 0" />
  </div>
</template>

<script>
export default {
  name: 'YiShengLieBiao',
  data() {
    return {
      doctorName: '',
      doctorJobList: [],
      titleCode: '',
      deptCode: '',
      type: '',
      loading: false,
      expandMap: {} // 控制每个医生简介的展开收起状态
    }
  },
  created() {
    this.titleCode = this.$route.query.titleCode || ''
    this.deptCode = this.$route.query.deptCode || ''
    this.doctorName = this.$route.query.doctorName || ''
    this.type = this.$route.query.type || ''
    this.getData()
  },
  mounted() {
    // 组件挂载后，强制更新一次来触发文本计算
    this.$nextTick(() => {
      this.$forceUpdate()
    })
  },
  methods: {
    getData() {
      this.loading = true
      this.$Apis.getSzsgjyyDoctorJobTitleInfo({
        titleCode: this.titleCode,
        deptCode: this.deptCode,
        doctorName: this.doctorName,
        campusArea: this.type
      }).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.doctorJobList = res.data
          this.$nextTick(() => {
            this.$forceUpdate()
          })
        } else {
          this.$toast(res.message)
        }
      }).catch(err => {
        this.loading = false
        this.$toast(err.message)
      })
    },
    goTo(item) {
      this.$router.push(`/zhuanjiaguahao?doctorCode=${item.doctorCode}&deptCode=${item.deptCode}&doctorSex=${item.doctorSex}&type=${this.type}`)
    },
    toggleExpand(index) {
      this.$set(this.expandMap, index, !this.expandMap[index])
    },
    hasMoreContent(text) {
      // 如果DOM还没准备好，返回false
      if (!this.$el) {
        return false
      }

      const desc = this.$el.querySelector('.desc')
      // 如果没有找到.desc元素，返回false
      if (!desc) {
        return false
      }

      // 创建一个临时的 div 元素用于计算
      const el = document.createElement('div')
      el.style.cssText = `
        position: absolute;
        visibility: hidden;
        height: auto;
        width: ${desc.offsetWidth}px;
        font-size: 12px;
        line-height: 1.5;
      `
      el.innerText = text
      document.body.appendChild(el)

      // 获取实际高度
      const height = el.offsetHeight
      // 清除临时元素
      document.body.removeChild(el)

      // 判断是否超过3行 (12px * 1.5 * 3 = 54px)
      return height > 54
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
.yuyueguahao {
  width: 100%;
  padding-bottom: 10px;

  .yishengliebiao {
    padding: 2px;
    background: #FFFFFF;
    text-align: center;
    font-size: 16px;
    color: #555555;
  }

  .list-wrap {
    margin: 10px;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 12px;

    .list {
      display: flex;
      padding: 20px 8px;
      border-bottom: 1px solid #E6E6E6;

      &:last-child {
        border: none;
      }

      .img-wrap {
        width: 62px;
        height: 62px;
        border-radius: 50%;
        flex-shrink: 0;
        margin-right: 10px;
        overflow: hidden;

        .doctor-img {
          width: 62px;
          height: 62px;
        }
      }

      .info-wrap {
        flex: 1;

        .name {
          font-size: 16px;
          color: #2C2C2C;
        }

        .desc {
          font-size: 12px;
          line-height: 1.5;
          margin: 13px 0;
          color: #3A3A3A;
          position: relative;
          max-height: 54px;
          overflow: hidden;
          will-change: max-height;
          transition: max-height 0.25s cubic-bezier(0.4, 0, 0.2, 1);

          &.desc-expanded {
            max-height: 1000px;
          }

          &[data-has-more="true"] {
            &::after {
              content: '';
              position: absolute;
              bottom: 0;
              left: 0;
              right: 0;
              height: 24px;
              background: linear-gradient(to bottom, rgba(255,255,255,0), #fff);
              opacity: 1;
              transition: opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
              pointer-events: none;
            }

            &.desc-expanded::after {
              opacity: 0;
            }
          }
        }

        .title-wrap {
          display: flex;
          background: #1777FF;
          align-items: center;
          padding: 2px;
          padding-right: 10px;
          border-radius: 9px;

          .title-img {
            width: 14px;
            height: 14px;

            .v-img {
              width: 14px;
              height: 14px;
            }
          }

          .title {
            color: #FFFFFF;
            margin-left: 4px;
            font-size: 10px;
          }
        }

        .expand-btn {
          position: absolute;
          right: 0;
          bottom: 0;
          padding: 0 5px;
          background: #fff;
          color: #1777FF;
          cursor: pointer;
          font-size: 14px;
          z-index: 1;
          display: flex;
          align-items: center;

          .van-icon {
            transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
            transform-origin: center;
            will-change: transform;

            &.is-expanded {
              transform: rotate(180deg);
            }
          }
        }
      }
    }
  }
}
</style>
